import React from "react";

export const SubscriptionRenewalContext = React.createContext();